module.exports = __webpack_public_path__ + "static/media/multi-icon-3.859e6744.svg";